module.exports = __webpack_public_path__ + "static/media/even.7aadec4c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/even.jpeg
// module id = 278
// module chunks = 0